import dayjs, { type Dayjs } from 'dayjs'

export const applyTimeToDate = (
  date: Dayjs,
  defaultTime?: string,
  existingDateTime?: Dayjs | null,
): Dayjs => {
  if (existingDateTime) {
    return date.tz().withTimeFrom(existingDateTime)
  }

  if (defaultTime) {
    const parsedTime = dayjs(defaultTime, 'HH:mm', true)

    return date.tz().hour(parsedTime.hour()).minute(parsedTime.minute()).second(0).millisecond(0)
  }

  return date.tz().withCurrentTime()
}
